import { Directive, ElementRef, HostListener } from '@angular/core'
import { WindowRef } from '@spartacus/core'
import { MbEventListenerService } from '../../services/mb-event-listener/event-listener.service'
import { VisibilityEvent } from '../../components/types'

@Directive({
  selector: '[mbInView]'
})
export class MbInViewportDirective {

  private readonly headerHeight = 65

  constructor (private elRef: ElementRef<HTMLDivElement>,
               private eventListenerService: MbEventListenerService,
               private winRef: WindowRef) {
  }

  @HostListener('window:scroll')
  onScroll (): void {
    const elements = Array.from(this.winRef.document.querySelectorAll(this.elRef.nativeElement.tagName))
      .filter(el => {
        const colorContainerParent = el?.parentElement?.parentElement?.parentElement as HTMLDivElement
        const top = colorContainerParent?.classList?.contains('color-container')
          ? colorContainerParent.getBoundingClientRect()?.top ?? 0
          : el?.getBoundingClientRect()?.top ?? 0
        return (top - this.headerHeight) < 0
      })
      .sort((e1, e2) => {
        if (e1.getBoundingClientRect()?.top > e2.getBoundingClientRect()?.top) {
          return -1
        }
        return 1
      })
    const id = elements[0]?.getAttribute('id')?.split('.')?.[0] ?? ''
    this.eventListenerService.update({
      type: 'visibility',
      isInViewport: true
    } as VisibilityEvent, id)
  }
}
